module.exports = __webpack_public_path__ + "static/media/thermalInversionExample.dd8e5b7e.png";